export function getRelX(x) {
	return window.rendererWidth * x;
}

export function getRelY(y) {
	return window.rendererHeight * y;
}

export function getRel(x, y) {
	// Given a 0-1 value, returns the relative position in pixels
	return new PIXI.Point(getRelX(x), getRelY(y));
}
